import { useCallback, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { slideDetailLabel } from "shared/utils/slideUtils";

import AdminLayout from "components/admin/AdminLayout";
import CaseEditController from "components/admin/editCasePanel/CaseEditController";
import ApplicationState from "store/ApplicationState";

export type HistoryStateType = {
  label: string;
  prevUrl: string;
};

const AdminCasePage = () => {
  const location = useLocation();
  const adminCase = useSelector(({ admin }: ApplicationState) => admin.case);
  const adminSlide = useSelector(({ admin }: ApplicationState) => admin.slide);
  const adminDocument = useSelector(
    ({ admin }: ApplicationState) => admin.document?.document
  );

  const getTitle = useCallback(() => {
    if (adminDocument) {
      return ` - Document ${adminDocument.name}`;
    } else if (adminSlide) {
      return ` - Slide ${adminSlide.accession_number} ${slideDetailLabel(
        adminSlide
      )}`;
    } else if (adminCase) {
      return ` - Case ${adminCase.accession}`;
    } else {
      return "";
    }
  }, [adminCase, adminSlide, adminDocument]);

  const historyState = useRef<{ label: string; prevUrl: string } | undefined>(
    location.state as
      | {
          label: string;
          prevUrl: string;
        }
      | undefined
  );

  return (
    <AdminLayout logoLink={historyState.current?.prevUrl}>
      <>
        <Helmet>
          <title>QC Admin{getTitle()} - PathologyWatch</title>
        </Helmet>
        <CaseEditController historyState={historyState.current} />
      </>
    </AdminLayout>
  );
};

export default AdminCasePage;
